import { MutationTree } from "vuex";
import { SessionLastState } from "./models";
import { SessionsUtilsStateInterface } from "./state";

const mutation: MutationTree<SessionsUtilsStateInterface> = {
  setSessionLastState(
    state: SessionsUtilsStateInterface,
    payload: { session_guid: string; last_state: SessionLastState }
  ) {
    if (!state.session_state[payload.session_guid]) {
      state.session_state[payload.session_guid] = {
        last_state: payload.last_state,
      };
    } else if (
      !state.session_state[payload.session_guid].last_state ||
      new Date(payload.last_state?.at ?? 1) >
        new Date(state.session_state[payload.session_guid].last_state?.at ?? 0)
    ) {
      state.session_state[payload.session_guid].last_state = payload.last_state;
    }
  },
};

export default mutation;
